/*eslint-disable*/
import { useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import ProfileSubAdmins from "models/profile.modal";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledCollapse,
} from "reactstrap";

import UserProfileMenu from "components/UserProfileMenu";

var ps;

const Sidebar = (props) => {
  const [profiledata, setProfiledata] = useState();
  
  const userinfo = sessionStorage.getItem("type");
  useEffect(() => {
    if (userinfo == "sub-admin") {
      var sessionData = sessionStorage.getItem("type");

      ProfileSubAdmins.Getprofile()
        .then((respomce) => {
          setProfiledata(respomce?.data?.other_data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, []);

  const [collapseOpen, setCollapseOpen] = useState();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse

  const createLinks = (routes) => {
    // Check if routes are valid
    if (!routes || !Array.isArray(routes) || routes.length === 0) {
      return null;
    }
  
    const userType = sessionStorage.getItem("type"); // Get the user type from session storage
  
    // Filter routes based on user type and permissions
    const filteredRoutes =
      userType === "sub-admin"
        ? routes.filter((prop) =>
            profiledata?.permissions?.some((profile) => profile === prop.name)
          )
        : routes; // No filtering for admin
  
    const [openDropdowns, setOpenDropdowns] = useState(
      filteredRoutes.map(() => false)
    );
  
    const toggleDropdown = (index) => {
      setOpenDropdowns((prev) => {
        const updatedDropdowns = [...prev];
        // Close the dropdown if it's currently open, otherwise open it
        updatedDropdowns[index] = !updatedDropdowns[index]; 
        // Close all other dropdowns
        updatedDropdowns.forEach((_, i) => {
          if (i !== index) updatedDropdowns[i] = false; // Close all others
        });
        return updatedDropdowns;
      });
    };
  
    return filteredRoutes.map((prop, key) => {
      if (prop && prop.IsVisible) {
        return (
          <NavItem key={key}  >
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={(e) => {
                if (prop.children) {
                  e.preventDefault(); // Prevent the default link behavior
                  toggleDropdown(key); // Toggle the dropdown when clicked
                }
              }}
              activeClassName="activeNavLink"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className={prop.icon} />
                  <span style={{ marginLeft: "0.5rem" }}>{prop.name}</span>
                </div>
                {prop.children && (
                  <i
                    className={`fa-solid fa-caret-${openDropdowns[key] ? "up" : "down"}`}
                    style={{
                      color: "gray",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent click event from bubbling up
                      toggleDropdown(key); // Toggle the dropdown when clicked
                    }}
                  ></i>
                )}
              </div>
            </NavLink>
  
            {prop.children && openDropdowns[key] && (
              <Collapse isOpen={openDropdowns[key]}>
                <NavItem
                  component="div"
                  style={{
                    paddingLeft: "1rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {(userType === "sub-admin"
                    ? prop.children.filter((child) =>
                        profiledata?.permissions?.some(
                          (profile) => profile === child.name
                        )
                      )
                    : prop.children // No filtering for admin
                  ).map((child, index) => (
                    <div key={index} style={{ marginBottom: "0.5rem" }}>
                      <NavLink
                        to={prop.layout + child.path}
                        tag={NavLinkRRD}
                        activeClassName="activeNavLink"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#f5f5f5",
                          color: "black",
                          padding: "0.5rem 1rem",
                          borderRadius: "0.25rem",
                        }}
                      >
                        <i className={child.icon} />
                        <span style={{ marginLeft: "0.5rem" }}>
                          {child.name}
                        </span>
                      </NavLink>
                    </div>
                  ))}
                </NavItem>
              </Collapse>
            )}
          </NavItem>
        );
      } else {
        return null;
      }
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }
  const handleLogout = async (e) => {
    e.preventDefault();
    sessionStorage.clear();
    window.location.assign("/auth/login");
  };

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
              style={{ maxHeight: "75px" }}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <UserProfileMenu />
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>

          {/* Navigation */}
          <Nav navbar>{createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className="my-3" />
          {/* Navigation */}
          <Nav className="mb-md-3" navbar>
            <NavItem>
              <NavLink onClick={handleLogout} style={{ cursor: "pointer" }}>
                <i className="fa-solid fa-right-from-bracket" />
                Logout
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
